import { render, staticRenderFns } from "./Facility.vue?vue&type=template&id=4e508efc&scoped=true&lang=pug"
import script from "./Facility.vue?vue&type=script&lang=ts"
export * from "./Facility.vue?vue&type=script&lang=ts"
import style0 from "./Facility.vue?vue&type=style&index=0&id=4e508efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e508efc",
  null
  
)

export default component.exports